var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useEffect, useState } from "react";
import { Button } from "../../tremor/Button";
import { Text } from "../../tremor/Text";
import { useBackend } from "../../layouts";
import { useDashboard } from "../../layouts/Dashboard/useDashboard";
import { toast } from "sonner";
import { useAutomationsModal } from "./useAutomationsModal";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import cronstrue from "cronstrue";
dayjs.extend(relativeTime);
dayjs.extend(utc);
dayjs.extend(timezone);
export const AutomationSidebar = ({}) => {
    const { open, selectedAutomation, setSelectedAutomation } = useAutomationsModal();
    const { backend, account, embedUser } = useBackend();
    const { dashboard } = useDashboard();
    const [automations, setAutomations] = useState([]);
    useEffect(() => {
        if (open && dashboard) {
            getAllAutomations();
        }
    }, [open, dashboard]);
    const getAllAutomations = () => __awaiter(void 0, void 0, void 0, function* () {
        if (!backend || !dashboard)
            return;
        const response = yield backend.automations.list({
            dashboard: dashboard === null || dashboard === void 0 ? void 0 : dashboard.id,
        });
        setAutomations(response);
        if (response.length > 0 && !(selectedAutomation === null || selectedAutomation === void 0 ? void 0 : selectedAutomation.id)) {
            setSelectedAutomation(response[0]);
        }
    });
    const createAutomation = () => __awaiter(void 0, void 0, void 0, function* () {
        toast.promise(() => __awaiter(void 0, void 0, void 0, function* () {
            let newAutomation = yield (backend === null || backend === void 0 ? void 0 : backend.automations.create({
                title: "Automation " + (automations.length + 1),
                description: "",
                dashboard: dashboard === null || dashboard === void 0 ? void 0 : dashboard.id,
                schedule: "",
                enabled: false,
                output_format: "pdf",
                method: "email",
                email_body: "Hello!<br /><br/>Here is your automated email from Onvo AI.",
                email_subject: "",
                email_cc: [],
                email_to: (account === null || account === void 0 ? void 0 : account.email) || (embedUser === null || embedUser === void 0 ? void 0 : embedUser.email),
                timezone: dayjs.tz.guess().replace("Calcutta", "Kolkata")
            }));
            yield getAllAutomations();
            return newAutomation;
        }), {
            loading: "Creating automation...",
            success: (newAutomation) => {
                // @ts-ignore
                setSelectedAutomation(newAutomation || null);
                return "Automation created";
            },
            error: (e) => {
                return "Error creating automation: " + e.message;
            }
        });
    });
    return (React.createElement("div", { className: "onvo-w-full onvo-h-full onvo-foreground-color dark:onvo-bg-slate-950" },
        React.createElement(Button, { variant: "primary", className: "onvo-w-[calc(100%-16px)] onvo-m-2", onClick: createAutomation }, "+ New automation"),
        automations.map(a => (React.createElement("div", { key: a.id, className: "onvo-py-2 onvo-px-3 onvo-rounded-lg onvo-mx-2 onvo-cursor-pointer " + ((selectedAutomation === null || selectedAutomation === void 0 ? void 0 : selectedAutomation.id) === a.id ? "onvo-bg-black/10 dark:onvo-bg-white/10" : ""), onClick: () => {
                setSelectedAutomation(a);
            } },
            React.createElement(Text, { className: "onvo-font-semibold" }, a.title),
            React.createElement(Text, { className: "!onvo-text-xs onvo-mt-1" },
                " ",
                a.schedule.trim() === "" ? "Automation not setup" : cronstrue.toString(a.schedule, { verbose: true })))))));
};
//# sourceMappingURL=AutomationsSidebar.js.map